import styled from "styled-components";

export const Container = styled.div`
  z-index: 1;
  width: 100%;
  height: 100vh;

  background: linear-gradient(to right, #e71037, #ed933a);
`;

export const InfoSec = styled.div`
  color: #fff;
  margin: 5%;
`;

export const ContainerInfo = styled.div``;

export const InfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: row;
`;

export const InfoColumn = styled.div``;

export const TextWrapper = styled.div`
  max-width: 540px;
`;

export const TopLine = styled.div`
  color: #f7f8fa;
  font-size: 18px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  margin-bottom: 16px;
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: #f7f8fa;

  @media screen and (max-width: 960px) {
    width: 100%;
    font-size: 3vh;
  }
`;

export const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  color: #f7f8fa;
`;

export const Button = styled.button`
  border-radius: 10px;
  background: white;
  white-space: nowrap;
  padding: 12px 64px;
  color: red;
  font-size: 20px;
  outline: none;
  border: none;
  cursor: pointer;
  &:hover {
    transition: all 0.3s ease-out;
    background: #ED933A;
    background-color: #ED933A;
  }
  @media screen and (max-width: 960px) {
    width: 100%;
    padding: 12px 14px;
    font-size: 15px;
  }
`;

export const ImgWrapper = styled.div`
  max-width: 555px;
  display: flex;
  justify-content: flex-end;
`;

export const Img = styled.img`
  padding-right: 0;
  border: 0;
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
  max-height: 500px;
`;
